import { render } from "./BaseAward.vue?vue&type=template&id=5e193e48&scoped=true"
import script from "./BaseAward.vue?vue&type=script&lang=js"
export * from "./BaseAward.vue?vue&type=script&lang=js"

import "./BaseAward.vue?vue&type=style&index=0&id=5e193e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e193e48"]])

export default __exports__